// extracted by mini-css-extract-plugin
module.exports = {"active":"LeftNavTeamTab_active__1Uurb","inactive":"LeftNavTeamTab_inactive__VRxKQ","addButton":"LeftNavTeamTab_addButton__3inU9","addIcon":"LeftNavTeamTab_addIcon__2CbBo"};